import { defineMessages } from "react-intl";

export default defineMessages({
  apiLoginSuccess: {
    id: `apiLoginSuccess`,
    defaultMessage: "Logged in successfully"
  }
});
